export default __webpack_public_path__ + "static/assets/ac71335f6961bc4cefd47ea36f4ea6ea.png";